var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.theme.toLowerCase()==='telekom')?_c('v-toolbar',{attrs:{"color":"primary","fixed":"","height":"16px","dark":"","flat":"","app":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }